var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoliticsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4586_2561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0881 3.35294H13.3262L12.7673 0H10.6175V1.11765H11.8205L12.1931 3.35294H6.80656L7.17911 1.11765H8.38218V0H6.23231L5.67349 3.35294H3.91159H2.79395V4.47059H3.91159V12.2941H5.02924V19H13.9704V12.2941H15.0881V4.47059H16.2057V3.35294H15.0881ZM12.8528 17.8824H6.14689V16.7647H12.8528V17.8824ZM12.8528 15.6471H6.14689V12.2941H12.8528V15.6471ZM7.26453 11.1765V6.70588H11.7351V11.1765H7.26453ZM13.9704 11.1765H12.8528V5.58824H6.14689V11.1765H5.02924V4.47059H13.9704V11.1765Z",
    fill: "#264653"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4586_2561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliticsIcon);
export default __webpack_public_path__ + "static/media/PoliticsIcon.2fbe98719fe6ee8b0e22ce08940fdcff.svg";
export { ForwardRef as ReactComponent };